import React from 'react'
import Slider from 'react-slick'

class CustomerSpeaks extends React.Component {
  constructor(props) {
    super(props)
    this.showChar = 210
    this.state = {
      showMore: [true, true, true, true, true],
      isShowmore: false,
    }
  }

  componentDidMount() {
    this.setState({ isShowmore: window.innerWidth > 500 ? true : false })
  }

  onShowMore = index => {
    var showMore = [...this.state.showMore]
    showMore[index] = !showMore[index]
    this.setState({ showMore })
  }

  getDefaultText = (text, index) => {
    if (this.state.isShowmore) {
      if (this.state.showMore[index] && text.length > this.showChar) {
        var c = text.substr(0, this.showChar)
        return c + '...'
      } else {
        return text
      }
    } else {
      return text
    }
  }

  render() {
    var settings = {
      dots: false,
      infinite: true,
      arrows: true,
      autoplay: true,
      speed: 800,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 770,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2,
          },
        },
        {
          breakpoint: 510,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
          },
        },
      ],
    }
    const { list } = this.props
    return (
      <section className="section-clients section">
        <div className="container-fluid mr-auto text-center pd-0">
          <h2 className="st-title ttl-mr">
            Customer <span className="infity-color">Reviews</span>
          </h2>
          <Slider {...settings} className="client-carousel">
            {list.map((item, index) => {
              return (
                <div className="client-carousel-item" key={index}>
                  <div className="client-box">
                    <div className="reviews-block-slide">
                      <div className="reviews-block-text client-description lightgrey-color ">
                        <div className="cl-quote">
                          <img
                            alt=""
                            src="/images/image-icons/icon-quote.png"
                          />
                        </div>
                        <div
                          className={
                            !this.state.showMore[index]
                              ? 'cus-review expand'
                              : 'cus-review'
                          }
                        >
                          <strong>{item.shortDescription} </strong>{' '}
                          <span className="review-more">
                            {this.getDefaultText(
                              item.longDescription.longDescription,
                              index
                            )}
                            {this.state.showMore[index] &&
                              this.state.isShowmore && (
                                <span
                                  className="morelink"
                                  onClick={() => this.onShowMore(index)}
                                >
                                  {' '}
                                  More
                                </span>
                              )}
                            {!this.state.showMore[index] &&
                              this.state.isShowmore && (
                                <span
                                  className="morelink"
                                  onClick={() => this.onShowMore(index)}
                                >
                                  {' '}
                                  Less
                                </span>
                              )}
                          </span>
                        </div>
                      </div>
                      <div
                        className="reviews-block-person "
                        data-wow-delay=".3s"
                      >
                        <div className="reviews-block-person-data">
                          <div className="reviews-block-person-name">
                            {item.personName}{' '}
                            <span className="person-role lightgrey-color">
                              {item.personRole}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </Slider>
        </div>
      </section>
    )
  }
}

export default CustomerSpeaks
